import {CockpitCard} from 'shared/dtos/cockpit-card';
import {CockpitKontrolleM1} from 'shared/dtos/cockpit-kontrolle/cockpit-kontrolle';
import {
  AnzahlProKategorie,
  PruefungDerVariablenM1
} from 'shared/dtos/cockpit-kontrolle/pruefung-der-variablen';
import {DataStorageService} from 'shared/services/data-storage.service';
import {TableExportService} from 'shared/services/table-data-export/table-data-export.service';

import {Component, ElementRef, OnInit} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

import {CockpitContentComponent} from '../../../cockpit-shared/cockpit-content-component';
import {CurrentLocaleComponent} from 'shared/components/current-locale-component';

@Component({
  selector: 'app-pruefung-der-variablen',
  templateUrl: './chart-dialog-pruefung-der-variablen-m1.component.html',
  styleUrl: './chart-dialog-pruefung-der-variablen-m1.component.scss',
  standalone: false
})
export class ChartDialogPruefungDerVariablenM1Component
  extends CurrentLocaleComponent
  implements OnInit, CockpitContentComponent
{
  cockpitKontrolle: CockpitKontrolleM1;
  pruefungDerVariablen: PruefungDerVariablenM1;
  ausbildung: AnzahlProKategorie[];
  card: CockpitCard;

  constructor(
    private readonly dataStorageService: DataStorageService,
    private readonly tableDataExport: TableExportService,
    protected readonly translate: TranslateService,
    private readonly element: ElementRef
  ) {
    super(translate);
  }

  async ngOnInit(): Promise<void> {
    super.ngOnInit();
    this.cockpitKontrolle =
      (await this.dataStorageService.getCockpitKontrolle()) as CockpitKontrolleM1;
    this.pruefungDerVariablen = this.cockpitKontrolle?.pruefungDerVariablen;
    this.ausbildung = this.pruefungDerVariablen?.Ausbildung.reverse();
  }

  downloadTable() {
    this.tableDataExport.exportHtmlTableInElement(
      this.element.nativeElement,
      this.card.title,
      null,
      'pruefungDerVariablenVerteilungProVariableM1'
    );
  }
}
